var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpleForm, SaveButton } from "react-admin";
import Checkbox from "@mui/material/Checkbox";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { Divider, FormControlLabel, Typography } from "@mui/material";
import { EmptyBox } from "./SettingsElectionsTypes";
import { IMPORT_TENANT_CONFIG } from "@/queries/ImportTenantConfig";
import { EXPORT_TENANT_CONFIG } from "@/queries/ExportTenantConfig";
import { useMutation } from "@apollo/client";
import { ETasksExecution } from "@/types/tasksExecution";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { DownloadDocument } from "../User/DownloadDocument";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
export var SettingsBackupRestore = function () {
    var _a = useWidgetStore(), addWidget = _a[0], setWidgetTaskId = _a[1], updateWidgetFail = _a[2];
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var t = useTranslation().t;
    var _b = useState(false), isLoading = _b[0], setLoading = _b[1];
    var _c = useState(), exportDocumentId = _c[0], setExportDocumentId = _c[1];
    var _d = useState(false), openImportDrawer = _d[0], setOpenImportDrawer = _d[1];
    var _e = useState({}), importConfigurations = _e[0], setImportConfigurations = _e[1];
    var export_tenant_config = useMutation(EXPORT_TENANT_CONFIG, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.TENANT_READ,
            },
        },
    })[0];
    var handleBackup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, documentId, task_id, e_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.EXPORT_TENANT_CONFIG, undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, export_tenant_config({
                            variables: {
                                tenantId: tenantId,
                            },
                        })];
                case 2:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    documentId = (_b = data === null || data === void 0 ? void 0 : data.export_tenant_config) === null || _b === void 0 ? void 0 : _b.document_id;
                    if (errors || !documentId) {
                        updateWidgetFail(currWidget.identifier);
                        console.log("Error exporting tenant config: ".concat(errors));
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    task_id = (_c = data === null || data === void 0 ? void 0 : data.export_tenant_config) === null || _c === void 0 ? void 0 : _c.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    setExportDocumentId(documentId);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    updateWidgetFail(currWidget.identifier);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var import_tenant_config = useMutation(IMPORT_TENANT_CONFIG, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.TENANT_WRITE,
            },
        },
    })[0];
    var handleRestore = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, task_id, e_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.IMPORT_TENANT_CONFIG, undefined);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    setLoading(true);
                    setOpenImportDrawer(false);
                    return [4 /*yield*/, import_tenant_config({
                            variables: {
                                tenantId: tenantId,
                                documentId: documentId,
                                importConfigurations: {
                                    include_tenant: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeTenant,
                                    include_keycloak: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeKeycloak,
                                    include_roles: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeRoles,
                                },
                                sha256: sha256,
                            },
                        })];
                case 2:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        updateWidgetFail(currWidget.identifier);
                        console.log("Error importing tenant config: ".concat(errors));
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    task_id = (_b = data === null || data === void 0 ? void 0 : data.import_tenant_config) === null || _b === void 0 ? void 0 : _b.task_execution.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _c.sent();
                    updateWidgetFail(currWidget.identifier);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleImportOptionsChange = function (name, event) {
        var checked = event.target.checked;
        setImportConfigurations(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = checked, _a)));
        });
    };
    if (!tenantId) {
        return (_jsx(EmptyBox, __assign({ m: 1 }, { children: _jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("electionTypeScreen.common.emptyHeader") })) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ className: "title", variant: "h4" }, { children: t("settings.backupRestore.title") })), _jsx(StyledDivider, {}), _jsx(SimpleForm, __assign({ className: "backup-form", toolbar: _jsx(SaveButton, { className: "save", label: t("settings.backupRestore.backup.label"), alwaysEnable: true, disabled: isLoading }), resource: "sequent_backend_tenant", onSubmit: handleBackup }, { children: _jsx(Typography, __assign({ variant: "h6" }, { children: t("settings.backupRestore.backup.subtitle") })) })), _jsx(StyledDivider, {}), _jsxs(SimpleForm, __assign({ className: "restore-form", resource: "sequent_backend_tenant", toolbar: _jsx(SaveButton, { className: "save", label: t("settings.backupRestore.restore.label"), alwaysEnable: true, disabled: 
                    // TODO: fix disable mode
                    isLoading ||
                        !(!!(importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeTenant) &&
                            !!(importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeKeycloak) &&
                            !!(importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeRoles)) }), onSubmit: function () {
                    setOpenImportDrawer(true);
                } }, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: t("settings.backupRestore.restore.subtitle") })), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeTenant, onChange: function (event) { return handleImportOptionsChange("includeTenant", event); } }), label: t("settings.backupRestore.restore.tenantConfigOption") }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeKeycloak, onChange: function (event) {
                                return handleImportOptionsChange("includeKeycloak", event);
                            } }), label: t("settings.backupRestore.restore.keycloakConfigOption") }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: importConfigurations === null || importConfigurations === void 0 ? void 0 : importConfigurations.includeRoles, onChange: function (event) { return handleImportOptionsChange("includeRoles", event); } }), label: t("settings.backupRestore.restore.RolesConfigOption") })] })), exportDocumentId && (_jsx(_Fragment, { children: _jsx(DownloadDocument, { documentId: exportDocumentId, fileName: "tenant-config-".concat(tenantId, "-export.zip"), onDownload: function () {
                        console.log("onDownload called");
                        setExportDocumentId(undefined);
                        setLoading(false);
                    }, onSucess: function () { return setLoading(false); } }) })), _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "settings.backupRestore.restore.title", subtitle: "settings.backupRestore.restore.subtitle", paragraph: "settings.backupRestore.restore.paragraph", doImport: handleRestore, errors: null })] }));
};
var StyledDivider = function () {
    return _jsx(Divider, { sx: { padding: "10px" } });
};
